// extracted by mini-css-extract-plugin
export var current_occupancy = "buildingCapacityNotice-module--current_occupancy--9eee8";
export var invisible = "buildingCapacityNotice-module--invisible--59a43";
export var message = "buildingCapacityNotice-module--message--8e0da";
export var visible = "buildingCapacityNotice-module--visible--a2e08";